<ul class="navbar-nav main-navigation main-navigation-list">
  <ish-lazy-content-include includeId="include.icsa.header.navigation.pagelet2-Include" />
  <custom-lazy-dot-cms-header-navigation />
</ul>
